import { Modal } from '@/components/Modal'

interface CalculatorModalProps {
	open: boolean
	onClose: () => void
	url: string
}

export function CalculatorModal ({
	open,
	onClose,
	url
}: CalculatorModalProps) {
	return (
		<Modal
			open={open}
			onClose={onClose}
			title='Expense Calculator'
			fullScreen
			spacesClass='spaces-calculator-modal'
		>
			{/* Older iOS WebKit won't clip an iframe to an ancestor's border-radius; redundant where it does. */}
			<div className='spaces:relative spaces:flex spaces:items-center spaces:justify-center spaces:w-full spaces:h-full spaces:bg-canvas-4 spaces:rounded-b-24'>
				{url
					? (
						<iframe
							src={url}
							title='Expense Calculator'
							className='spaces:w-full spaces:h-full spaces:border-0 spaces:rounded-b-24'
							allow='autoplay; fullscreen'
						/>
					)
					: (
						<p className='spaces:text-14/16 spaces:font-default spaces:text-content-1 spaces:text-center spaces:max-w-[800px]'>
							[ Calculator Embedded Here – No URL ]
						</p>
					)}
			</div>
		</Modal>
	)
}
